// Converts #word in HTML text to clickable hashtag links.
// Splits on HTML tags so # inside attributes is never replaced.
const linkifyHashtags = (html) => {
    if (!html || typeof html !== 'string') return html;
    return html
        .split(/(<[^>]*>)/g)
        .map((part, i) => {
            if (i % 2 !== 0) return part; // HTML tag — leave untouched
            return part.replace(
                /#(\w+)/g,
                '<a href="/hashtag/$1" class="post-hashtag" data-tag="$1">#$1</a>'
            );
        })
        .join('');
};

export default linkifyHashtags;
